module.exports = __webpack_public_path__ + "static/siteBG-552a05b756bec51b2efc333da2ebc014.jpg";